
















import iconCheck from '@/assets/svg/rounded/check.svg?inline'
import Vue from 'vue'
import { CheckboxValue } from '@/models/dataTable'

interface Props {
  value: CheckboxValue[]
  inputValue: CheckboxValue
  rounded: boolean
  theme: string
  disable: boolean
}
interface Computed {
  model: CheckboxValue[]
  isChecked: CheckboxValue
}

export default Vue.extend<{}, {}, Computed, Props>({
  components: {
    iconCheck,
  },
  props: {
    value: {
      required: false,
    },
    inputValue: {
      default: false,
    },
    rounded: {
      default: false,
    },
    theme: {},
    disable: {
      default: false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    isChecked() {
      if (Array.isArray(this.value)) {
        return this.value.includes(this.inputValue)
      }
      return this.inputValue
    },
  },
})
